import React from 'react';
import PropTypes from 'prop-types';
import { Alignment } from '../Alignment';
import style from './TitleBackgroundImage.scss';

export const TitleBackgroundImage = ({
  align,
  children,
  hideIconBackground: hide
}) => {
  const imgClass = !hide ? '-image' : '';
  return (
    <Alignment xs={align}>
      <div className={style[`title-background${imgClass}`]}>
        <div className={style[`title-background${imgClass}__avatar`]}>
          {children}
        </div>
      </div>
    </Alignment>
  );
};

TitleBackgroundImage.propTypes = {
  align: PropTypes.oneOf(['center', 'right', 'left']),
  hideIconBackground: PropTypes.bool
};

TitleBackgroundImage.defaultProps = {
  align: 'center',
  hideIconBackground: false
};
